<template>
  <div v-if="!item.hidden && !(item.meta && item.meta.hidden)">
    <!-- 无子菜单：直接渲染菜单项 -->
    <template v-if="!hasChildren(item)">
      <app-link :to="resolvePath(item.path)">
        <el-menu-item :index="resolvePath(item.path)">
          <i :class="(item.meta && item.meta.icon) || 'el-icon-document'" />
          <span slot="title">{{ item.meta && item.meta.title }}</span>
        </el-menu-item>
      </app-link>
    </template>

    <!-- 仅首页（path=/）单子项可扁平；目录菜单始终保留二级 -->
    <template v-else-if="canFlatten(item)">
      <app-link :to="resolvePath(onlyOneChild.path)">
        <el-menu-item :index="resolvePath(onlyOneChild.path)">
          <i :class="(onlyOneChild.meta && onlyOneChild.meta.icon) || (item.meta && item.meta.icon) || 'el-icon-document'" />
          <span slot="title">{{ (onlyOneChild.meta && onlyOneChild.meta.title) || (item.meta && item.meta.title) }}</span>
        </el-menu-item>
      </app-link>
    </template>

    <!-- 多个子项 / 业务目录：渲染子菜单 -->
    <el-submenu v-else :index="resolvePath(item.path)" popper-append-to-body>
      <template slot="title">
        <i :class="(item.meta && item.meta.icon) || 'el-icon-folder'" />
        <span>{{ item.meta && item.meta.title }}</span>
      </template>
      <sidebar-item
        v-for="child in showingChildren"
        :key="child.path"
        :item="child"
        :base-path="resolvePath(item.path)"
        :is-nest="true"
      />
    </el-submenu>
  </div>
</template>

<script>
import AppLink from './Link.vue'

export default {
  name: 'SidebarItem',
  components: { AppLink },
  props: {
    item: { type: Object, required: true },
    basePath: { type: String, default: '' },
    isNest: { type: Boolean, default: false }
  },
  data() {
    return {
      onlyOneChild: null
    }
  },
  computed: {
    showingChildren() {
      const children = (this.item && this.item.children) || []
      return children.filter(child => !(child.hidden || (child.meta && child.meta.hidden)))
    }
  },
  methods: {
    hasChildren(item) {
      return item.children && item.children.length > 0
    },
    canFlatten(item) {
      // 只有「控制台」这种根路由扁平；业务一级目录始终显示二级菜单
      if (!item || item.path !== '/') return false
      const showing = this.showingChildren
      if (showing.length === 1) {
        this.onlyOneChild = showing[0]
        return true
      }
      return false
    },
    resolvePath(routePath) {
      if (!routePath) return this.basePath || '/'
      if (/^(https?:|mailto:|tel:)/.test(routePath)) return routePath
      if (routePath.startsWith('/')) return routePath
      const base = (this.basePath || '').replace(/\/+$/, '')
      if (!base) return `/${routePath}`.replace(/\/+/g, '/')
      return `${base}/${routePath}`.replace(/\/+/g, '/')
    }
  }
}
</script>
